export default "__VITE_ASSET__8f790747__"